import React from "react";

const TeamMeetingIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 13.5H18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2 12.5V11.5814C2 10.8732 2.188 10.1777 2.54491 9.56589L4.92117 5.49229C5.27955 4.87776 5.93744 4.5 6.64871 4.5H17.3513C18.0626 4.5 18.7204 4.87776 19.0788 5.49229L21.4551 9.56589C21.812 10.1777 22 10.8732 22 11.5814V12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 17.5V12.5C2 10.8431 3.34315 9.5 5 9.5H19C20.6569 9.5 22 10.8431 22 12.5V17.5C22 19.1569 20.6569 20.5 19 20.5H15.9051C15.0148 20.5 14.1704 20.1045 13.6005 19.4206L12 17.5L10.3995 19.4206C9.82962 20.1045 8.98518 20.5 8.09486 20.5H5C3.34315 20.5 2 19.1569 2 17.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default TeamMeetingIcon;
